/* Powerplugs – PP 1 nov (kopie-thema)
   1) Mobiel: zwevende knoppen (Google-badge, WebwinkelKeur-badge) schuiven boven de sticky winkelmandbalk.
   2) Zolang de cookiebanner open is: chatknop en badges tijdelijk verborgen, zodat ze de knoppen
      'Accepteren' / 'Weigeren' niet bedekken. De cookiebanner zelf blijft ongewijzigd werken.
   3) Sticky winkelmandbalk (app XB): Engelse knoptekst vertaald naar NL / FR. */
(function () {
  var root = document.documentElement;
  var loc = String(window.PP_LOCALE || root.lang || 'nl').slice(0, 2).toLowerCase();
  var T = loc === 'fr'
    ? { 'add to cart': 'Ajouter au panier', 'sold out': 'Épuisé', 'unavailable': 'Indisponible', 'buy now': 'Acheter maintenant' }
    : { 'add to cart': 'In winkelmand', 'sold out': 'Uitverkocht', 'unavailable': 'Niet beschikbaar', 'buy now': 'Nu kopen' };

  function translateSticky(el) {
    if (!el) return;
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var k = n.nodeValue.trim().toLowerCase();
      if (T[k]) n.nodeValue = n.nodeValue.replace(n.nodeValue.trim(), T[k]);
    }
    el.querySelectorAll('[value],[aria-label],[title]').forEach(function (b) {
      ['aria-label', 'title'].forEach(function (a) {
        var v = b.getAttribute(a);
        if (v && T[v.trim().toLowerCase()]) b.setAttribute(a, T[v.trim().toLowerCase()]);
      });
      if (b.tagName === 'INPUT' && (b.type === 'submit' || b.type === 'button') && T[(b.value || '').trim().toLowerCase()]) {
        b.value = T[b.value.trim().toLowerCase()];
      }
    });
  }

  function visible(el) {
    if (!el) return false;
    var cs = getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && el.offsetHeight > 0;
  }

  function layout() {
    var mobile = window.innerWidth < 750;
    var banner = document.getElementById('shopify-pc__banner');
    root.classList.toggle('pp-cookie-open', visible(banner));

    var sticky = document.getElementById('xb-sticky-add-to-cart');
    var off = 0;
    if (mobile && visible(sticky)) {
      var r = sticky.getBoundingClientRect();
      if (r.top < window.innerHeight - 4) off = Math.ceil(window.innerHeight - r.top);
    }
    root.style.setProperty('--pp-satc-h', off + 'px');
    root.classList.toggle('pp-satc-on', off > 0);

    var g = document.getElementById('google-merchantwidget-iframe-wrapper');
    if (g) {
      if (g.dataset.ppBottom === undefined) g.dataset.ppBottom = g.style.bottom || '';
      if (off > 0) g.style.setProperty('bottom', (off + 12) + 'px', 'important');
      else if (g.dataset.ppBottom) g.style.setProperty('bottom', g.dataset.ppBottom, 'important');
    }
    translateSticky(sticky);
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; layout(); });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('click', function () { setTimeout(layout, 300); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', layout); else layout();
  setInterval(layout, 1000);
})();
